import { useEffect, useState } from "react";
import { DESKTOP, MOBILE, TABLET } from "@/utils/appConstants";
import useStore from "./useStore";

const useUtils = () => {
  const { appState } = useStore();
  const [device, setDevice] = useState();
  const [observer, setObserver] = useState();
  const [scrollY, setScrollY] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [scrollX, setScrollX] = useState(0);

  const decodeTitle = (title) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = title;
    return txt.value;
  };

  const convertToRelative = (url) => {
    const path = url.replace(appState.site.url, "");
    return path;
  };

  const isExternal = (url) => {
    const domain = (url) => {
      return url.replace("http://", "").replace("https://", "").split("/")[0];
    };
    return domain(location.href) !== domain(url);
  };

  const isDevice = (val) => {
    if (val < 768) {
      return setDevice(MOBILE);
    } else if (val >= 768 && val < 1024) {
      return setDevice(TABLET);
    } else if (val >= 1024) {
      return setDevice(DESKTOP);
    }
  };

  const getDate = (date, full = false) => {
    const [day, fullDate] = date.split("|");
    if (full && fullDate) return fullDate;
    return day;
  };

  useEffect(() => {
    const body = document.querySelector("body");
    body.addEventListener("scroll", () => {
      setScrollY(body.scrollY);
      setScrollX(body.scrollX);
    });
  }, []);

  useEffect(() => {
    const resizeHandler = () => {
      isDevice(window.innerWidth);
    };

    if (!observer) {
      setObserver(
        new ResizeObserver((entries) => {
          for (const entry of entries) {
            isDevice(entry.contentRect.width);
          }
        })
      );
    }

    if (observer) {
      isDevice(window.innerWidth); // Set initial device type
      observer.observe(document.documentElement); // observe the root element

      window.addEventListener("resize", resizeHandler);

      return () => {
        observer.disconnect();
        window.removeEventListener("resize", resizeHandler);
      };
    }
  }, [observer]);

  return {
    convertToRelative,
    decodeTitle,
    device,
    getDate,
    isExternal,
    scroll,
    scrollY,
  };
};

export default useUtils;
